import * as React from 'react';

export const CloseIcon = () => {
    return (
        <svg
            width='11'
            height='11'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.25 0.75L0.75 11.25M0.75 0.75L11.25 11.25'
                stroke='white'
                stroke-opacity='0.5'
                stroke-width='1.5'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};
